<template>
  <div class="service-area pt--70 pb--70 bg_color--1">
    <v-container>
      <v-row>
        <v-col md="10" offset-md="1" cols="12">
          <div class="text-center section-title mb--30">
            <h3 class="heading-title pb--30">What we do</h3>
            <p class="description">
              We provide high quality affordable accommodation to building
              contractors and professionals in Birmingham and the West Midlands.
              In doing so we keep landlords and estate agents properties filled
              with reliable tenants.
            </p>
          </div>
        </v-col>
      </v-row>
      <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" class="text-center section-title mt--60 mb--30">
        <h3 class="heading-title">Services</h3>
        <Service class="mt--50" />
      </div>
    </v-container>
  </div>
</template>
<script>
import Service from "../components/Service";
export default {
  components: {
    Service,
  },
};
</script>
